import React, { useState, useEffect } from "react";
import { PageTitle } from "../../components";
import {
  Table,
  Space,
  Button,
  Form,
  Input,
  Select,
  Modal,
  Tabs,
  message,
  Skeleton,
  Checkbox,
} from "antd";
import dayjs from "dayjs";
import { Routes, Route, useParams, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { CURRENT_CLUB_ID } from "../../_helpers/constants";
import { ranksApi } from "../../_helpers/apiService";

const { Option } = Select;
const { TabPane } = Tabs;

interface DataType {
  key?: string;
  name?: string;
  order?: number;
  min_point?: number;
  max_point?: number;
  is_rank?: boolean;
}

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },
};

function Rank() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [data, setData] = useState<DataType>({});
  const [loading, setLoading] = useState(true);

  let { rankId } = useParams();

  useEffect(() => {
    if (rankId) {
      fetchRankData();
    }
  }, [rankId]);

  const fetchRankData = async () => {
    if (!rankId) return;

    setLoading(true);
    try {
      const response = await ranksApi.getById(parseInt(rankId));
      const rankData = response.data;

      setData(rankData);
      form.setFieldsValue(rankData);
    } catch (error: any) {
      console.error("Error fetching rank data:", error);
      message.error("Цолын мэдээлэл татахад алдаа гарлаа");
    } finally {
      setLoading(false);
    }
  };

  const getRanks = async () => {
    try {
      const response = await ranksApi.getAll({
        club_id: CURRENT_CLUB_ID,
        limit: 1000,
        sort_by: 'order',
        sort_order: 'asc'
      });

      const ranksObject: any = {};
      response.data.items.forEach((rank: any) => {
        ranksObject[rank.id] = rank;
      });

      return ranksObject;
    } catch (error) {
      console.error("Error fetching ranks:", error);
      return {};
    }
  };

  const onFinish = () => {
    form
      .validateFields()
      .then(async (values) => {
        if (rankId) {
          try {
            await ranksApi.update(parseInt(rankId), {
              name: values.name,
              order: parseInt(values.order),
              min_point: values.min_point ? parseInt(values.min_point) : undefined,
              max_point: values.max_point ? parseInt(values.max_point) : undefined,
              is_rank: values.is_rank || false,
              club_id: CURRENT_CLUB_ID,
            });

            message.success("Амжилттай.");

            // Update Redux store with latest ranks
            const ranks = await getRanks();
            dispatch({ type: "SET_RANKS", payload: ranks });

            // Refresh data
            fetchRankData();
          } catch (error: any) {
            console.error("Error updating rank:", error);
            message.error("Цол засахад алдаа гарлаа");
          }
        }
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  return (
    <>
      {data ? (
        <PageTitle
          loading={loading}
          title={`${data?.name}`}
          right={null}
          breadcrumbItems={[
            { link: "/ranks", title: "Цол" },
            { title: `${data?.name} ` },
          ]}
        />
      ) : (
        ""
      )}
      <div className="page-content-wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <Skeleton loading={loading} active>
                    <Form
                      {...formItemLayout}
                      form={form}
                      onFinish={onFinish}
                      initialValues={{
                        is_rank: false,
                      }}
                    >
                      <Form.Item
                        label="Нэр"
                        name="name"
                        rules={[{ required: true, message: "Нэр оруулна уу!" }]}
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item
                        label="Дугаар"
                        name="order"
                        rules={[
                          { required: true, message: "Дугаар оруулна уу!" },
                        ]}
                      >
                        <Input type="number" />
                      </Form.Item>
                      <Form.Item
                        label="Min point"
                        name="min_point"
                        rules={[
                          { required: false, message: "Min point оруулна уу!" },
                        ]}
                      >
                        <Input type="number" />
                      </Form.Item>
                      <Form.Item
                        label="Max point"
                        name="max_point"
                        rules={[
                          { required: false, message: "Max point оруулна уу!" },
                        ]}
                      >
                        <Input type="number" />
                      </Form.Item>
                      <Form.Item
                        label="Цолны чимэг эсэх"
                        name="is_rank"
                        valuePropName="checked"
                      >
                        <Checkbox />
                      </Form.Item>
                      <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
                        <Button type="primary" htmlType="submit">
                          Хадгалах
                        </Button>
                      </Form.Item>
                    </Form>
                  </Skeleton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Rank;
